import * as ActionTypes from '../actions/types/CashSettingsActionTypes';

const cashSettingsReducer = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_CASH_FEE_SETTINGS: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.RECEIVE_CASH_FEE_SETTINGS: {
      return Object.assign({}, state, action.payload, { busy: false });
    }
    default:
      return state;
  }
};

export default cashSettingsReducer;



// WEBPACK FOOTER //
// ./src/reducers/cashSettings.js